import { Injectable } from '@angular/core'
import { PageEvent } from '@angular/material/paginator'
import { BehaviorSubject } from 'rxjs'

import { History } from '@shared/models/history.model'
import { PagesData } from '@shared/models/pages-data.model'

@Injectable({
  providedIn: 'root',
})
export class StatusHistoryDataService {
  paginator = {
    pageIndex: 0,
    previousPageIndex: null,
    pageSize: 10,
    length: null,
  }
  private readonly historyData = new BehaviorSubject<PagesData<History>>(null)
  historyData$ = this.historyData.asObservable()

  private readonly pageEvent = new BehaviorSubject<PageEvent>(this.paginator)
  pageEvent$ = this.pageEvent.asObservable()

  setPageEvent(pageEvent: PageEvent): void {
    this.pageEvent.next(pageEvent)
  }

  setHistoryData(history: PagesData<History>): void {
    this.historyData.next(history)
  }
}
